<template src="./template.html" ></template>

<script>
import vueAxios from '../../functions/vueAxios'
import utils from '../../functions/utils'
import MyButtons from '../../pages/add/Buttons.vue'

export default {
  name: 'printLabel',
  components: {
    MyButtons
  },
  data() {
    return {
      // اطلاعات فاکتور
      data: {},
      // نمایش جدول
      showWeightTable: false,
      weightSplits: [],
    }
  },

  async beforeCreate() {
    const subRoute = this.$router.currentRoute.path.split('/')[1]
    const mid = this.$router.currentRoute.path.split('/')[3]
    await this.$store.dispatch('getInfo', {
      url: `/api/${subRoute}`,
      params: {
        mid
      }
    })
    this.data = this.$store.getters.editData
    this.showWeightTable = true
  },

  computed: {

    typeTitle() {
      const type = this.data.type
      const title = {
        sale: 'فاکتور فروش',
        pay: 'سند پرداخت امانی'
      }
      return title[type] || ''
    }

  },

  watch: {

    showWeightTable(newVal) {
      if (
        newVal &&
        this.data &&
        Array.isArray(this.data.items) &&
        this.data.items.length
      ) {
        this.initializeWeightSplits()
      }

      // فوکوس روی اولین input
      this.$nextTick(() => {

        const firstInput =
          this.$el.querySelector(
            'tbody tr:first-child input'
          )

        if (firstInput) {
          firstInput.focus()
        }

      })
    }

  },

  methods: {

    // 1. عنوان محصول
    productTitle(group) {
      const product = group?.product
      if (!product) {
        return 'محصول'
      }
      return (product.title || product.name || product.caption || product.code || 'محصول')
    },
    // 2. پیدا کردن محصول
    findProduct(productId) {
      return (this.data.products || []).find(
        product =>
        String(product._id) === String(productId)
      ) || null
    },
    // 3. ساخت واحدهای محصول
    buildUnits(product) {
      if (!product) {
        return []
      }
      if (product.unit2) {
        return [{
            n: 1,
            title: product.unit1
          },
          {
            n: Number(product.n) || 1,
            title: product.unit2
          }
        ]
      }

      return [{
        n: 1,
        title: product.unit1
      }]
    },

    // 4. محاسبه وزن یک سطر فاکتور
    getItemWeight(item) {

      let value = 0

      if (this.data.type === 'sale') {

        value =
          Math.abs(
            Number(item.value) || 0
          )

      } else if (this.data.type === 'pay') {

        value =
          Math.abs(
            Number(item.lending_value) || 0
          )
      }


      // ضریب واحد همین سطر
      //
      // 1       = گرم
      // 4.608.. = مثقال
      //
      const n =
        Number(item.product?.n) || 1


      // تبدیل به واحد پایه
      const baseWeight =
        value * n


      return Math.round(
        baseWeight * 1000
      ) / 1000
    },

    // 5. ساخت ساختار اصلی weightSplits
    initializeWeightSplits() {

      const items =
        Array.isArray(this.data.items) ?
        this.data.items : []

      const products =
        Array.isArray(this.data.products) ?
        this.data.products : []


      // -------------------------------------------------------
      // گروه‌بندی سطرها بر اساس product_id
      // -------------------------------------------------------

      const groups = {}

      items.forEach((item, itemIndex) => {

        // فقط سطرهایی که product_id دارند
        if (!item.product_id) {
          return
        }

        const productId =
          String(item.product_id)


        if (!groups[productId]) {
          groups[productId] = []
        }


        groups[productId].push({
          item,
          itemIndex
        })

      })


      const result = []


      // -------------------------------------------------------
      // ساخت گروه برای هر محصول
      // -------------------------------------------------------

      Object.keys(groups).forEach(productId => {

        const groupItems =
          groups[productId]


        const product =
          products.find(
            p =>
            String(p._id) ===
            String(productId)
          )


        if (!product) {
          return
        }


        // واحدهای قابل انتخاب محصول
        const units =
          this.buildUnits(product)


        if (!units.length) {
          return
        }


        // -----------------------------------------------------
        // وزن پایه تجمیعی محصول
        //
        // هر سطر ابتدا به واحد پایه تبدیل می‌شود.
        // -----------------------------------------------------

        let totalBaseWeight = 0


        groupItems.forEach(
          ({
            item
          }) => {

            totalBaseWeight +=
              this.getItemWeight(item)

          }
        )


        totalBaseWeight =
          Math.round(
            totalBaseWeight * 1000
          ) / 1000


        // -----------------------------------------------------
        // واحد سطر اول فاکتور
        //
        // فقط برای نمایش وزن تجمیعی استفاده می‌شود.
        // واحد واقعی هر split جداگانه حفظ می‌شود.
        // -----------------------------------------------------

        const firstItem =
          groupItems[0]?.item


        const firstItemN =
          Number(
            firstItem?.product?.n
          ) || 1


        const firstUnit =
          units.find(
            unit =>
            Math.abs(
              Number(unit.n) -
              firstItemN
            ) < 1e-12
          ) || units[0]


        // -----------------------------------------------------
        // وزن تجمیعی را به واحد سطر اول نمایش می‌دهیم
        // -----------------------------------------------------

        const invoiceDisplayWeight =
          firstItemN ?
          utils.round3(
            totalBaseWeight /
            firstItemN
          ) :
          utils.round3(
            totalBaseWeight
          )


        // -----------------------------------------------------
        // ساخت splits
        // -----------------------------------------------------

        const splits =
          groupItems.map(
            ({
              item,
              itemIndex
            }) => {

              // واحد واقعی همین سطر
              const itemN =
                Number(
                  item.product?.n
                ) || 1


              const itemUnit =
                units.find(
                  unit =>
                  Math.abs(
                    Number(unit.n) -
                    itemN
                  ) < 1e-12
                ) || units[0]


              // وزن واقعی همان سطر در واحد خودش
              const itemValue =
                this.data.type === 'sale'

                ?
                Math.abs(
                  Number(
                    item.value
                  ) || 0
                )

                :
                Math.abs(
                  Number(
                    item.lending_value
                  ) || 0
                )


              return {

                split_id: `invoice-${item._id || itemIndex}`,

                item_id: item._id || null,

                invoiceItemIndex: itemIndex,

                // وزن در واحد خودش
                weight: utils.round3(
                  itemValue
                ),

                // ضریب واحد خودش
                n: itemUnit.n,

                count: 1,

                prevUnit: itemUnit.n

              }

            }
          )


        // -----------------------------------------------------
        // ساخت گروه نهایی
        // -----------------------------------------------------

        result.push({

          product_id: productId,

          product,

          units,

          invoiceWeight: {

            // وزن تجمیعی در واحد سطر اول
            weight: invoiceDisplayWeight,

            n: firstUnit.n,

            unit: firstUnit.title

          },

          // وزن پایه واقعی برای محاسبات
          invoiceBaseWeight: totalBaseWeight,

          splits

        })

      })


      this.weightSplits = result
    },

    // 6. وزن فاکتور بر اساس واحد پایه
    invoiceWeightBase(group) {

      if (
        Number.isFinite(
          Number(group?.invoiceBaseWeight)
        )
      ) {
        return Number(
          Number(group.invoiceBaseWeight).toFixed(3)
        )
      }

      const weight =
        Number(
          group?.invoiceWeight?.weight
        ) || 0

      const n =
        Number(
          group?.invoiceWeight?.n
        ) || 1

      return Number(
        (weight * n).toFixed(3)
      )
    },

    // 7. مجموع وزن تقسیم‌شده یک محصول
    totalWeightBase(group) {

      if (!group?.splits?.length) {
        return 0
      }

      const total = group.splits.reduce(
        (acc, row) => {

          const weight =
            Number(row.weight) || 0

          const n =
            Number(row.n) || 1

          const count =
            Number(row.count) || 1

          return acc + (
            weight * n * count
          )

        },
        0
      )

      return Number(
        total.toFixed(3)
      )
    },

    // 8. نمایش مجموع وزن
    totalWeightDisplay(group) {

      const totalBase =
        this.totalWeightBase(group)

      const n =
        Number(
          group?.invoiceWeight?.n
        ) || 1

      return utils.round3(
        totalBase / n
      )
    },

    // 9. آیا وزن بیشتر شده؟
    isOverWeight(group) {

      const total =
        this.totalWeightBase(group)

      const invoice =
        this.invoiceWeightBase(group)

      return (
        total - invoice
      ) > 0.001
    },

    // 10. آیا وزن کمتر شده؟
    isUnderWeight(group) {

      const total =
        this.totalWeightBase(group)

      const invoice =
        this.invoiceWeightBase(group)

      return (
        invoice - total
      ) > 0.001
    },

    // 11. رنگ مجموع
    totalColor(group) {

      const total =
        this.totalWeightBase(group)

      const invoice =
        this.invoiceWeightBase(group)


      if (
        Math.abs(total - invoice) <
        1e-6
      ) {
        return 'green'
      }


      if (total > invoice) {
        return 'red'
      }


      return 'orange'
    },

    // 12. آیا امکان افزودن ردیف وجود دارد؟
    disableAddRow(group) {

      return (
        this.totalWeightBase(group) >=
        this.invoiceWeightBase(group) -
        1e-9
      )
    },

    // 13. مجموع سایر سطرها
    SumOfWeightsWithoutThisRow(group, index) {

      const otherRowsTotal = group.splits.filter(
          (_, i) => i !== index
        )
        .reduce(
          (acc, row) => {

            const weight =
              Math.abs(
                Number(row.weight) || 0
              )

            const n =
              Number(row.n) || 1

            const count =
              Number(row.count) || 1


            return acc +
              (
                weight *
                n *
                count
              )

          },
          0
        )


      return (
        this.invoiceWeightBase(group) -
        otherRowsTotal
      )
    },

    // =========================================================
    // تغییر واحد یک ردیف
    // =========================================================

    calculateRemainingWeight(group, index) {

      const row =
        group?.splits?.[index]

      if (!row) {
        return
      }


      // واحد جدید
      const newN =
        Number(row.n) || 1


      // واحد قبلی
      const oldN =
        Number(row.prevUnit) || newN


      // -------------------------------------------------------
      // اگر واحد تغییر کرده باشد،
      // وزن فعلی را ابتدا به واحد پایه
      // و سپس به واحد جدید تبدیل می‌کنیم.
      // -------------------------------------------------------

      if (
        oldN !== newN &&
        row.weight !== '' &&
        row.weight !== null &&
        row.weight !== undefined
      ) {

        const currentWeight =
          Number(row.weight)


        if (Number.isFinite(currentWeight)) {

          const baseWeight =
            currentWeight * oldN


          row.weight =
            utils.round3(
              baseWeight / newN
            )
        }
      }


      // -------------------------------------------------------
      // اگر ردیف خالی باشد،
      // باقیمانده را برای آن محاسبه کن.
      // -------------------------------------------------------

      if (
        row.weight === '' ||
        row.weight === null ||
        row.weight === undefined
      ) {

        this.fillRemainingWeight(
          group,
          index
        )
      }


      // واحد فعلی را ذخیره می‌کنیم
      row.prevUnit = newN
    },

    // =========================================================
    // ورود به فیلد وزن
    // =========================================================

    onWeightFocus(group, index) {

      const row =
        group?.splits?.[index]

      if (!row) {
        return
      }


      // اگر مقدار خالی است،
      // همان لحظه باقیمانده را محاسبه کن.

      if (
        row.weight === '' ||
        row.weight === null ||
        row.weight === undefined
      ) {

        this.fillRemainingWeight(
          group,
          index
        )
      }
    },

    // =========================================================
    // تغییر مقدار وزن
    // =========================================================

    onWeightChanged(group, index) {

      const row =
        group?.splits?.[index]

      if (!row) {
        return
      }


      // وقتی کاربر در حال پاک کردن فیلد است،
      // چیزی را به صفر تبدیل نکن.
      //
      // اجازه بده مقدار خالی بماند تا
      // focus / blur بتواند باقیمانده را محاسبه کند.

      if (
        row.weight === '' ||
        row.weight === null ||
        row.weight === undefined
      ) {
        return
      }


      const weight =
        Number(row.weight)


      if (!Number.isFinite(weight)) {
        return
      }


      row.weight =
        utils.round3(
          Math.max(
            0,
            weight
          )
        )
    },

    // =========================================================
    // خروج از فیلد وزن
    // =========================================================

    onWeightBlur(group, index) {

      const row =
        group?.splits?.[index]

      if (!row) {
        return
      }


      // اگر فیلد خالی است،
      // باقیمانده را پر کن.

      if (
        row.weight === '' ||
        row.weight === null ||
        row.weight === undefined
      ) {

        this.fillRemainingWeight(
          group,
          index
        )

        return
      }


      const weight =
        Number(row.weight)


      if (!Number.isFinite(weight)) {

        this.fillRemainingWeight(
          group,
          index
        )

        return
      }


      row.weight =
        utils.round3(
          Math.max(
            0,
            weight
          )
        )
    },

    // =========================================================
    // محاسبه و پر کردن باقیمانده وزن
    // =========================================================

    fillRemainingWeight(group, index) {

      const row =
        group?.splits?.[index]

      if (!row) {
        return
      }


      // -------------------------------------------------------
      // وزن کل این محصول در واحد پایه
      // -------------------------------------------------------

      const invoiceBase =
        this.invoiceWeightBase(group)


      // -------------------------------------------------------
      // مجموع تمام ردیف‌ها به جز ردیف فعلی
      //
      // ردیف فعلی عمداً حذف می‌شود چون قرار است
      // مقدار آن را با باقیمانده پر کنیم.
      // -------------------------------------------------------

      const otherRowsBase =
        group.splits
        .filter(
          (_, i) => i !== index
        )
        .reduce(
          (acc, otherRow) => {

            const weight =
              Number(otherRow.weight) || 0

            const n =
              Number(otherRow.n) || 1

            const count =
              Math.max(
                1,
                Number(otherRow.count) || 1
              )


            return acc +
              (
                weight *
                n *
                count
              )

          },
          0
        )


      // -------------------------------------------------------
      // باقیمانده در واحد پایه
      // -------------------------------------------------------

      const remainingBase =
        Math.max(
          0,
          invoiceBase -
          otherRowsBase
        )


      // -------------------------------------------------------
      // واحد ردیف فعلی
      // -------------------------------------------------------

      const n =
        Number(row.n) || 1


      // -------------------------------------------------------
      // تعداد بسته
      // -------------------------------------------------------

      const count =
        Math.max(
          1,
          Number(row.count) || 1
        )


      // -------------------------------------------------------
      // وزن هر بسته
      //
      // مثلاً:
      //
      // باقیمانده = 1000 گرم
      // count = 2
      // n = 1
      //
      // weight = 500
      // -------------------------------------------------------

      const remainingPerPackage =
        remainingBase /
        (n * count)


      row.weight =
        utils.round3(
          Math.max(
            0,
            remainingPerPackage
          )
        )


      // برای اینکه تغییر واحد بعدی درست باشد
      row.prevUnit = n
    },

    // =========================================================
    // تغییر تعداد بسته
    // =========================================================

    onCountChanged(group, index) {

      const row =
        group?.splits?.[index]

      if (!row) {
        return
      }


      // اگر کاربر در حال پاک کردن است،
      // فعلاً دست نزن.

      if (
        row.count === '' ||
        row.count === null ||
        row.count === undefined
      ) {
        return
      }


      const count =
        Number(row.count)


      if (!Number.isFinite(count)) {
        return
      }


      row.count =
        Math.max(
          1,
          Math.floor(count)
        )
    },

    // =========================================================
    // خروج از فیلد تعداد
    // =========================================================

    onCountBlur(group, index) {

      const row =
        group?.splits?.[index]

      if (!row) {
        return
      }


      let count =
        Number(row.count)


      if (
        !Number.isFinite(count) ||
        count < 1
      ) {
        count = 1
      }


      row.count =
        Math.floor(count)


      // -------------------------------------------------------
      // اگر مقدار وزن این ردیف خالی باشد،
      // با توجه به تعداد جدید، باقیمانده را پر کن.
      // -------------------------------------------------------

      if (
        row.weight === '' ||
        row.weight === null ||
        row.weight === undefined
      ) {

        this.fillRemainingWeight(
          group,
          index
        )
      }
    },

    // =========================================================
    // افزودن ردیف تقسیم جدید
    // =========================================================

    addWeightRow(group, index) {

      if (
        !group ||
        !Array.isArray(group.splits)
      ) {
        return
      }


      const currentRow =
        group.splits[index]

      if (!currentRow) {
        return
      }


      // -------------------------------------------------------
      // وزن کل فاکتور این محصول
      // -------------------------------------------------------

      const invoiceBase =
        this.invoiceWeightBase(group)


      // -------------------------------------------------------
      // مجموع تمام ردیف‌های موجود
      //
      // نکته مهم:
      // اینجا نباید ردیف فعلی حذف شود.
      // چون ردیف جدید باید فقط باقیمانده واقعی
      // بعد از تمام ردیف‌های موجود را بگیرد.
      // -------------------------------------------------------

      const usedBase =
        this.totalWeightBase(group)


      // -------------------------------------------------------
      // باقیمانده
      // -------------------------------------------------------

      const remainingBase =
        Math.max(
          0,
          invoiceBase -
          usedBase
        )


      // اگر چیزی برای تقسیم باقی نمانده،
      // ردیف جدید ایجاد نکن.

      if (
        remainingBase <= 1e-9
      ) {
        return
      }


      // -------------------------------------------------------
      // واحد ردیف جدید
      //
      // پیش‌فرض همان واحد ردیف فعلی است.
      // -------------------------------------------------------

      const currentN =
        Number(currentRow.n) || 1


      // -------------------------------------------------------
      // ردیف جدید
      // -------------------------------------------------------

      const newRow = {

        split_id: `split-${Date.now()}-${Math.random()
          .toString(36)
          .slice(2)}`,

        item_id: null,

        invoiceItemIndex: null,

        weight: utils.round3(
          remainingBase /
          currentN
        ),

        n: currentN,

        count: 1,

        prevUnit: currentN

      }


      // -------------------------------------------------------
      // بعد از ردیف فعلی قرار بده
      // -------------------------------------------------------

      group.splits.splice(
        index + 1,
        0,
        newRow
      )
    },

    // =========================================================
    // 18. حذف ردیف
    // =========================================================

    removeWeightRow(
      group,
      index
    ) {

      if (
        group.splits.length <= 1
      ) {
        return
      }


      group.splits.splice(
        index,
        1
      )
    },


    // =========================================================
    // 19. چاپ یک لیبل در حالت عادی
    // =========================================================

    async printLabel(item) {

      try {

        const product =
          this.findProduct(
            item.product_id
          )


        const value = !item.second_value

          ?
          Math.abs(
            Number(
              item.value
            ).toFixed(3)
          )

          :
          Math.abs(
            Number(
              (
                item.value /
                (
                  product?.n ||
                  1
                )
              ).toFixed(3)
            )
          )


        const res =
          await vueAxios.get(
            '/invoices/label', {
              params: {

                amount: value,

                unit: item.n === 1 ?
                  'G' : 'M',

                invoice_id: this.data.id,

                invoice_date: item.invoice_date

              },

              responseType: 'blob'
            }
          )


        const file =
          new Blob(
            [res.data], {
              type: 'application/pdf'
            }
          )


        const fileURL =
          URL.createObjectURL(file)


        window.open(
          fileURL,
          '_blank'
        )


        setTimeout(() => {

          URL.revokeObjectURL(
            fileURL
          )

        }, 2000)


      } catch (err) {

        console.error(
          '❌ Error fetching label PDF:',
          err
        )

      }
    },


    // =========================================================
    // 20. چاپ مستقیم یک split
    // =========================================================

    async printLabelwithoutShow(
      group,
      item
    ) {

      try {

        // -----------------------------------------------------
        // محصول همین جدول
        // -----------------------------------------------------

        const product =
          group.product


        if (!product) {

          console.error(
            'Product not found for label'
          )

          return
        }


        const res =
          await vueAxios.get(
            '/invoices/label', {

              params: {

                amount: item.weight,

                unit: item.n,

                invoice_id: this.data.id,

                invoice_date: this.data.create_date,

                // بسیار مهم:
                // اینجا دیگر اولین محصول فاکتور ارسال نمی‌شود.
                // محصول متعلق به همین جدول ارسال می‌شود.
                product: product

              },

              responseType: 'blob'

            }
          )


        const file =
          new Blob(
            [res.data], {
              type: 'application/pdf'
            }
          )


        const fileURL =
          URL.createObjectURL(file)


        const iframe =
          document.createElement(
            'iframe'
          )


        iframe.style.display =
          'none'

        iframe.src =
          fileURL


        document.body.appendChild(
          iframe
        )


        iframe.onload = () => {

          const printWindow =
            iframe.contentWindow


          printWindow.focus()

          printWindow.print()

        }


        // بعد از چاپ، iframe را حذف می‌کنیم
        setTimeout(() => {

          try {

            document.body.removeChild(
              iframe
            )

          } catch (e) {
            console.log(e);
          }

          URL.revokeObjectURL(
            fileURL
          )

        }, 5000)


      } catch (err) {

        console.error(
          '❌ Error fetching QR PDF:',
          err
        )

      }
    },


    // =========================================================
    // 21. چاپ تمام لیبل‌ها
    // =========================================================

    async printAllLabels() {

      // -------------------------------------------------------
      // ابتدا تمام گروه‌های محصولات
      // -------------------------------------------------------

      for (
        const group of this.weightSplits
      ) {

        // -----------------------------------------------------
        // سپس تمام split های همان محصول
        // -----------------------------------------------------

        for (
          const item of group.splits
        ) {

          // ---------------------------------------------------
          // تعداد چاپ
          // ---------------------------------------------------

          const count =
            Math.max(
              1,
              Number(item.count) || 1
            )


          for (
            let i = 0; i < count; i++
          ) {

            await this.printLabelwithoutShow(
              group,
              item
            )


            // فاصله کوتاه بین چاپ‌ها
            await new Promise(
              resolve =>
              setTimeout(
                resolve,
                500
              )
            )

          }

        }

      }


      // فوکوس مجدد روی اولین input
      this.$nextTick(() => {

        const firstInput =
          this.$el.querySelector(
            'tbody tr:first-child input'
          )

        if (firstInput) {
          firstInput.focus()
        }

      })

    }

  }

}
</script>

<style scoped>
.total h2 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.product-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.product-total {
  font-size: 16px;
  color: gray;
  font-weight: normal;
}
</style>
